import { render, staticRenderFns } from "./ViewImageModal.vue?vue&type=template&id=2851bade&scoped=true"
import script from "./ViewImageModal.vue?vue&type=script&lang=js"
export * from "./ViewImageModal.vue?vue&type=script&lang=js"
import style0 from "./ViewImageModal.vue?vue&type=style&index=0&id=2851bade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851bade",
  null
  
)

export default component.exports